import { render } from "./PerfilUsuario.vue?vue&type=template&id=4cc607cf"
import script from "./PerfilUsuario.js?vue&type=script&lang=js&external"
export * from "./PerfilUsuario.js?vue&type=script&lang=js&external"

import "./PerfilUsuario.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__